import API from "../base.service";
import { ENDPOINT } from "../../constants.service";

const getAppSetting = async () => {
  const url = `${ENDPOINT.settings.appSettings.show}`;
  return await API.getMethod(url, true);
};
const updateAppSetting = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.settings.appSettings.update}`,
    true,
    data,
    true
  );
};

export default {
  getAppSetting,
  updateAppSetting,
};
